import { useEffect } from "react";
import { useGetMeQuery } from "../../gql/hooks";
import { ONESIGNAL_USER, setOneSignalUserId } from "./onesignal";

const useOneSignalUser = () => {
  const { data: me } = useGetMeQuery();

  useEffect(() => {
    if (!localStorage.getItem(ONESIGNAL_USER) && me?.me?.id) {
      setOneSignalUserId(`${me.me.id}`);
    }
  }, [me?.me]);
};

export default useOneSignalUser;
